/**
 * The Instagram account the marketing pages show. It lives outside React because the HTTP client reads it, and it is
 * kept in memory so that it still works where browser storage is blocked. null: the server's default, the latest connected.
 */
const STORAGE_KEY = 'pc.marketing-instagram-account';
const ACCOUNT_HEADER = 'X-Ig-Account';

function readStored(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStored(accountId: string | null): void {
  try {
    if (accountId === null) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, accountId);
    }
  } catch {
    // Remembering the account across visits is a convenience only.
  }
}

let selectedAccount = readStored();
const listeners = new Set<() => void>();

export function selectedInstagramAccount(): string | null {
  return selectedAccount;
}

export function storeInstagramAccount(accountId: string | null): void {
  selectedAccount = accountId;
  writeStored(accountId);
  listeners.forEach((listener) => listener());
}

export function subscribeToInstagramAccount(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function instagramAccountHeaders(): Record<string, string> {
  return selectedAccount === null ? {} : { [ACCOUNT_HEADER]: selectedAccount };
}
